import React, { useCallback, useEffect, useState } from 'react';
import DocumentsContext from './Documents.context';
import api from '../../api/api';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import { Document } from '../../models/Document';

interface DocumentsProps {
  children?: React.ReactNode;
}

const Documents: React.FC<DocumentsProps> = ({ children }) => {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [isLoading, setIsLoading] = useState<boolean | string>();

  const getDocuments = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data } = await api.getDocuments();
      setDocuments(data);
    } catch (e: any) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const downloadDocument = useCallback(async (doc: Document) => {
    try {
      setIsLoading(
        'Securing and packing document, this may take longer for bigger files.'
      );
      const { data } = await api.downloadDocument(doc.fileKey);
      const uint8Array = new Uint8Array(data.buffer.data);
      const blob = new Blob([uint8Array], {
        type: 'application/octet-stream',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${doc.fileName}.resolve`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e: any) {
      console.error(e);
      toast.error(e.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getDocuments();
  }, [getDocuments]);

  if (isLoading)
    return (
      <Loader label={typeof isLoading === 'string' ? isLoading : undefined} />
    );

  return (
    <DocumentsContext.Provider
      value={{ documents, setDocuments, downloadDocument }}
    >
      {children}
    </DocumentsContext.Provider>
  );
};

export default Documents;
